import ChevronDownIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/chevron-down';
import ChevronUpIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/chevron-up';

import type { I18nService } from '@shared/types/i18n';

import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  i18n: I18nService;
  isOpen: boolean;
};
const PriceBannerExpandIcon = ({ i18n: { translate }, isOpen }: Props) =>
  isOpen ? (
    <ChevronUpIcon ariaLabel={translate('hd_price_range_tip')} />
  ) : (
    <ChevronDownIcon ariaLabel={translate('hd_price_range_tip')} />
  );

export default withI18n(PriceBannerExpandIcon);
